<template>
    <Row v-bind="rowProp">
        <template v-for="(field, index) in fields" :key="index">
            <Col v-if="field.visible?.({ field })" v-bind="field.colProp?.({ field, index })">
                <template v-if="!field.visibleInput || field.visibleInput?.({ field })">
                    <template v-if="skeleton">
                        <Skeleton :paragraph="false" v-bind="field.skeletonProp?.({ field, index })"></Skeleton>
                    </template>
                    <template v-else-if="field.formItemRender">
                        <component :is="field.formItemRender?.({ field, index })"></component>
                    </template>
                    <template v-else>
                        <FormItem
                            :label="getLabel({ field })"
                            v-bind="{
                                ...useForm?.validateInfos?.[field.key],
                                ...customUseForm({ props, field }),
                                ...field.formItemProp?.({ field })
                            }"
                        >
                            <component :is="field.inputRender?.({ field, index })"></component>
                        </FormItem>
                    </template>
                </template>
            </Col>
        </template>
    </Row>
</template>

<script>
import { defineComponent } from "vue";
import { Form, Input, Row, Col, Skeleton, Checkbox } from "ant-design-vue";
import { customUseForm, getLabel } from "./template-builder.logic";

export default defineComponent({
    components: {
        FormItem: Form.Item,
        Input,
        InputPassword: Input.Password,
        TextArea: Input.TextArea,
        Row,
        Col,
        Skeleton,
        Checkbox
    },
    props: {
        rowProp: { default: () => {} },
        useForm: { default: () => ({ validateInfos: {} }) },
        fields: { default: () => [] },
        skeleton: { default: false }
    },
    setup(props) {
        return { props, getLabel, customUseForm };
    }
});
</script>
